// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1rVjT","header":"ReportDetails_header__3SMti","title":"ReportDetails_title__1s7cx","left":"ReportDetails_left__3zuD-"};